// Libs
import { FormControl, FormErrorMessage, FormHelperText, FormLabel, Input, InputGroup, InputLeftAddon, InputLeftElement, InputRightAddon, InputRightElement } from "@chakra-ui/react"

export default function Text({ label, error, helper, leftAddon, leftElement, rightAddon, rightElement, type = 'text', ...props }){
    return(
    <FormControl isInvalid={!!error}>
        { label && <FormLabel fontSize="sm" children={label} /> }
        <InputGroup>
            { !!leftAddon && <InputLeftAddon children={leftAddon} />  }
            { !!leftElement && <InputLeftElement children={leftElement} />  }
            <Input type={type} {...props} />
            { !!rightElement && <InputRightElement children={rightElement} />  }
            { !!rightAddon && <InputRightAddon children={rightAddon} />  }
        </InputGroup>
        { !!error && <FormErrorMessage children={error} /> }
        { (!error && !!helper) && <FormHelperText fontSize="xs" children={helper} />}
    </FormControl>
    )
}